/* eslint-disable jira/filename-case */
import React from 'react';
import type { Middleware, StoreState } from './types.tsx';

type Defaults = {
	/**
	 * @deprecated Batching is enabled by default in React 18+ and turning it off will be deprecated in next major
	 */
	batchUpdates: boolean;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	devtools: boolean | ((storeState: StoreState<any>) => Record<string, any>);
	middlewares: Set<Middleware>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	mutator: (currentState: any, setStateArg: any) => any;
};

const defaultMutator = <TState,>(prevState: TState, partialState: Partial<TState>) =>
	// Merge the partial state and the previous state.
	({ ...prevState, ...partialState });
const defaults: Defaults = {
	batchUpdates: 'useSyncExternalStore' in React,
	devtools: false,
	middlewares: new Set(),
	mutator: defaultMutator,
};

export default defaults;
